import { render, staticRenderFns } from "./LotteryBox.vue?vue&type=template&id=c00d7694&scoped=true"
import script from "./LotteryBox.vue?vue&type=script&lang=js"
export * from "./LotteryBox.vue?vue&type=script&lang=js"
import style0 from "./LotteryBox.vue?vue&type=style&index=0&id=c00d7694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00d7694",
  null
  
)

export default component.exports